// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"612fcc0f","591":"001d9931","687":"9f25439c","781":"e26f0cbb","791":"34c04bb2","852":"5779f6bd"}[chunkId] + ".chunk.js";
};